// extracted by mini-css-extract-plugin
export default {"tagsContainer":"ProposalStatusTags_tagsContainer__uv7wP","tag":"ProposalStatusTags_tag__Dj4Iz","status":"ProposalStatusTags_status__t5VG5"};